import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() propertyAddress: string = 'Default Property Address';
  @Input() title: string = 'Default Title';
  @Input() showTitle: boolean = false;
  @Input() details: any = { reportStatus: 'DRAFT' };
  @Input() loading: boolean = false;
  @Input() isHealthy$: Observable<boolean> = of(true);
  @Input() isEditVisible: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() saving: boolean = false;
  @Input() form: any;

  @Input() showSaveEdit: boolean = false;
  @Input() showHomeButton: boolean = false;
  @Input() showStatus: boolean = false;

  @Output() save = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();

  smallScreen: boolean = false; 

  constructor(private router: Router) {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.smallScreen = window.innerWidth <= 576;
  }

  onSave(value: boolean): void {
    this.save.emit(value);
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onHomeClick(): void {
    this.router.navigate(['/']);
  }
}